const humanize = (key) => {
  const text = String(key).replace(/[_-]+/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const flattenDetails = (value, label) => {
  if (value === null || value === undefined || value === '') return []

  if (Array.isArray(value)) {
    return value.reduce((all, item) => all.concat(flattenDetails(item, label)), [])
  }

  if (typeof value === 'object') {
    return Object.keys(value).reduce((all, key) => (
      all.concat(flattenDetails(value[key], humanize(key)))
    ), [])
  }

  const text = String(value)
  return [label ? `${label}: ${text}` : text]
}

// Rails endpoints in this app return validation details in several shapes:
// `message`, `error`, `detail`, or an `errors`/`messages` hash. Convert all of
// those to a short, React-safe string instead of leaking Axios's generic 422.
export const formatApiErrorDetails = (value) => flattenDetails(value).join('; ')

export const apiErrorMessage = (data) => {
  if (typeof data === 'string') return data
  if (!data || typeof data !== 'object') return ''

  const keys = ['message', 'error', 'detail', 'messages', 'errors']
  for (const key of keys) {
    const message = formatApiErrorDetails(data[key])
    if (message) return message
  }
  return ''
}
